import { render, staticRenderFns } from "./editWechat.vue?vue&type=template&id=60051f83&scoped=true"
import script from "./editWechat.vue?vue&type=script&lang=js"
export * from "./editWechat.vue?vue&type=script&lang=js"
import style0 from "./editWechat.vue?vue&type=style&index=0&id=60051f83&prod&lang=scss&scoped=true"
import style1 from "./editWechat.vue?vue&type=style&index=1&id=60051f83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60051f83",
  null
  
)

export default component.exports